export default "__VITE_ASSET__Dh5TgsVN__"